import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Landmark } from 'lucide-react';

const primaryTabs = [
  { to: '/dashboard/accounting', label: 'Ringkasan', end: true },
  { to: '/dashboard/accounting/coa', label: 'Bagan akun' },
  { to: '/dashboard/accounting/journals', label: 'Jurnal' },
  { to: '/dashboard/accounting/settings', label: 'Pengaturan' },
  { to: '/dashboard/accounting/reports/trial-balance', label: 'Laporan' },
];

function tabClass(active) {
  return `shrink-0 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all border ${
    active
      ? 'bg-[#2D6CDF] text-white border-[#2D6CDF] shadow-md shadow-[#2D6CDF]/25'
      : 'bg-white text-slate-600 border-slate-200 hover:border-[#2D6CDF]/40 hover:text-[#2D6CDF]'
  }`;
}

export default function AccountingLayout() {
  const { pathname } = useLocation();
  const onReports = pathname.includes('/accounting/reports');

  return (
    <div className="space-y-6" data-testid="accounting-layout">
      <div className="rounded-2xl border border-slate-200/80 bg-gradient-to-br from-slate-50 via-white to-[#2D6CDF]/[0.06] p-6 shadow-sm">
        <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#2D6CDF] text-white shadow-lg shadow-[#2D6CDF]/30">
              <Landmark className="h-6 w-6" />
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">Akuntansi</h1>
              <p className="text-sm text-slate-500">Buku besar, COA, dan laporan keuangan per tenant</p>
            </div>
          </div>
        </div>
        <nav className="mt-6 flex gap-2 overflow-x-auto pb-1 scrollbar-thin" aria-label="Menu akuntansi">
          {primaryTabs.map(({ to, label, end }) => {
            const reportTab = to.includes('/reports');
            return (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) => tabClass(isActive || (reportTab && onReports))}
              >
                {label}
              </NavLink>
            );
          })}
        </nav>
        {onReports && (
          <p className="mt-2 text-xs text-slate-500">Gunakan tab laporan di bawah untuk memilih jenis laporan.</p>
        )}
      </div>
      <Outlet />
    </div>
  );
}
